var _rect, _rect2, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconPmMastercard = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 66,
    height: 46,
    viewBox: "0 0 66 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 45,
    rx: 5.5,
    fill: "white"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 65,
    height: 45,
    rx: 5.5,
    stroke: "#E9EAEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40.9222 9.64062C48.0246 9.64062 53.7826 15.3902 53.7826 22.4824C53.7825 29.5746 48.0245 35.3242 40.9222 35.3242C37.7382 35.3242 34.8263 34.166 32.5804 32.252C30.3347 34.1658 27.4234 35.3241 24.2396 35.3242C17.1373 35.3242 11.3793 29.5746 11.3793 22.4824C11.3793 15.3902 17.1373 9.64062 24.2396 9.64062C27.4232 9.64073 30.3347 10.7983 32.5804 12.7119C34.8263 10.798 37.7383 9.64065 40.9222 9.64062Z",
    fill: "#ED0006"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40.9226 9.64062C48.0248 9.64074 53.782 15.3902 53.782 22.4824C53.7819 29.5745 48.0248 35.3241 40.9226 35.3242C37.7386 35.3242 34.8267 34.1659 32.5808 32.252C35.3446 29.8966 37.0993 26.3951 37.0994 22.4824C37.0994 18.5695 35.3448 15.0673 32.5808 12.7119C34.8267 10.7981 37.7387 9.64062 40.9226 9.64062Z",
    fill: "#F9A000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5801 12.7119C35.3444 15.0673 37.0986 18.5693 37.0986 22.4824C37.0986 26.3953 35.3441 29.8966 32.5801 32.252C29.8165 29.8966 28.0625 26.3949 28.0625 22.4824C28.0625 18.5697 29.8163 15.0673 32.5801 12.7119Z",
    fill: "#FF5E00"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconPmMastercard);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_PM_mastercard.041fc3cb1a885c4c1ae25a6797ebb639.svg";